import { DELETE_CREDIT_FAILURE, POST_CREDIT_FAILURE, UPDATE_CREDIT_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  deleteCredit,
  getHomesaleInfo,
  postCredit,
  updateCredit,
  updateEquity
} from 'modules/authorizations/store/actions/homesale.actions';
import { showToast } from 'modules/layout/layout.actions';
import MultiTabCard, { ContentType } from 'modules/common/multiTabCard/multiTabCard.component';
import { enumColumn } from 'modules/common/enumTableColumn';
import { formatMoney } from 'utilities/currencyFormatter';
import React, { useState } from 'react';

const CreditsChargesCard = props => {
  const { equity, expenseCodes, isReadOnly, fileId } = props;

  const equityInfo = equity ? equity.equityInfo : null;
  const credits = equity ? equity.creditCharges : null;

  const typeOptions = [
    { title: 'Credit', id: '936fc501-7a03-4c78-83d5-7ac32113d426' },
    { title: 'Charge', id: '0b3d5218-484a-49e3-9ea5-939f58c7a3f2' },
    { title: '', id: '00000000-0000-0000-0000-000000000000' }
  ];

  const [isLoading, setIsLoading] = useState(false);

  const enhancedExpenseCodes = expenseCodes && expenseCodes.map(ec => ({
    ...ec,
    displayName: `${ec.expenseCodeCode} - ${ec.expenseCodeDescription}`
  }));

  const expenseCodeSearchInfo = {
    searchingColumns: [
      { name: 'expenseCodeId', title: 'Id' },
      { name: 'expenseCodeCode', title: 'Expense Code' },
      { name: 'expenseCodeDescription', title: 'Description' },
      { name: 'classification', title: 'Classification' }
    ],
    searchingColumnExtensions: [
      { columnName: 'expenseCodeId', width: 150 },
      { columnName: 'expenseCodeCode', width: 175 },
      { name: 'expenseCodeDescription', width: 250 },
      { name: 'classification', width: 175 }
    ],
    searchingRows: enhancedExpenseCodes || [],
    idKey: 'expenseCodeId',
    nameKey: 'displayName'
  };

  const otherCreditsColumns = [
    {
      ...enumColumn('creditChargeTypeId', typeOptions),
      header: 'Type',
      type: 'dropdown-v2',
      options: typeOptions,
      required: true,
      size: 120,
      minSize: 120,
      displayInHeaderRow: true,
      Cell: ({ cell }) => cell.getValue() && <p>{cell.getValue()}</p>
    },
    {
      ...enumColumn('expenseCodeId', enhancedExpenseCodes, { valueKey: 'expenseCodeId', label: 'displayName' }),
      header: 'Expense Code',
      type: 'advanced-search',
      required: true,
      size: 220,
      minSize: 220,
      hideInTable: false,
      displayInHeaderRow: true,
      nameKey: 'displayName',
      searchInfo: expenseCodeSearchInfo
    },
    {
      accessorKey: 'amount',
      header: 'Amount',
      type: 'money',
      required: true,
      size: 155,
      minSize: 155,
      displayInHeaderRow: false,
      Cell: ({ cell }) => cell.row.original.amount != null && <p>{formatMoney(cell.row.original.amount)}</p>
    },
    {
      accessorKey: 'description',
      header: 'Description',
      type: 'text',
      required: false,
      size: 190,
      minSize: 190,
      hideInTable: false,
      displayInHeaderRow: false
    }
  ];

  const taxTabs = [
    {
      order: 1,
      contentType: ContentType.CrudTable,
      header: 'Credits & Charges',
      iconPath: ['fas', 'sack-dollar'],
      isDisabled: false,
      // headerMessage:
      //   equityInfo &&
      //   equityInfo.dateDetailsPosted &&
      //   `Posted Details Date: ${new Date(equityInfo.dateDetailsPosted).toLocaleDateString('en-us')}`,
      hideEdit: false
    }
  ];

  const updateCreditCharge = async (otherCreditCharge, values) => {
    let newValues = { ...otherCreditCharge.original };

    newValues.creditChargeTypeId = values.creditChargeTypeId;
    newValues.expenseCodeId = values.expenseCodeId;
    newValues.amount = values.amount;
    newValues.description = values.description;
    setIsLoading(true);
    const resp = await props.updateCredit(fileId, newValues);
    if (resp.type === UPDATE_CREDIT_FAILURE) {
      setIsLoading(false);
      return false;
    } else {
      await props.getHomesaleInfo(fileId);
      setIsLoading(false);
      return true;
    }
  };

  const createCreditCharge = async values => {
    setIsLoading(true);

    let newValues = { ...values };

    newValues.homesaleEquityId = equityInfo.homesaleEquityId;
    newValues.addedBy = 1;
    newValues.addedOn = new Date();
    newValues.description = values.description;
    newValues.acumaticaTransactionId = null;
    const resp = await props.postCredit(fileId, newValues);
    if (resp.type === POST_CREDIT_FAILURE) {
      setIsLoading(false);
      return false;
    } else {
      await props.getHomesaleInfo(fileId);
      setIsLoading(false);
      return true;
    }
  };

  const deleteCreditCharge = async vendor => {
    const id = vendor.original.homesaleEquityCreditChargeId;
    const resp = await props.deleteCredit(fileId, vendor.original.homesaleEquityId, id);
    if (resp.type === DELETE_CREDIT_FAILURE) {
      return false;
    } else {
      await props.getHomesaleInfo(fileId);
      return true;
    }
  };

  const taxesTableContents = [
    {
      contentType: ContentType.CrudTable,
      tabOrder: 1,
      columns: otherCreditsColumns,
      rows: credits,
      updateRow: updateCreditCharge,
      createRow: createCreditCharge,
      deleteRow: deleteCreditCharge,
      // getNameOfDeleteRow: getNameOfDeleteRow,
      customAddText: 'Add Credit / Charge',
      fixedColumnWidths: true,
      actionsColumnSize: 100,
      summaries: null,
      numColumns: null,
      updateFields: null,
      isLoading,
      hideEdit: isReadOnly,
      topLink: null
    }
  ];

  return <MultiTabCard tabs={taxTabs} contents={taxesTableContents} />;
};

export default compose(
  connect(null, {
    showToast,
    updateEquity,
    updateCredit,
    deleteCredit,
    postCredit,
    getHomesaleInfo
  })
)(CreditsChargesCard);
